<template>
  <v-form>
    <v-container>
      <v-card class="parkingSelect" outlined>
        <v-row>
          <v-card-title> 駐車場一覧 </v-card-title>
        </v-row>
      </v-card>
      <v-card class="risuto" outlined>
        <v-form ref="tableForm" v-model="tableForm" lazy-validation>
          <ryou-table
            ref="ryouTable"
            :rowKey="rowKey"
            :headers="headers"
            :handleEdit="handleEdit"
            :handleDelete="handleDelete"
            :queryParams="queryParam"
            :url="url"
            :businessKeys="businessKeys"
            :dummy="false"
            :needSearch="true"
            :height="height"
          >
            <v-row slot="filterContainer">
              <v-col cols="3" class="parkingSelectBox">
                <ryou-select
                  v-model="selectGroup"
                  :value="selectGroup"
                  :label="'物件グループ名'"
                  :items="objectGroupItems"
                  :itemText="'build_group_name'"
                  :itemValue="'build_group_id'"
                >
                </ryou-select>
              </v-col>
              <v-col cols="3" class="parkingSelectBox">
                <ryou-select
                  v-model="selectVehicleClass"
                  :value="selectVehicleClass"
                  :label="'車両区分名'"
                  :items="vehicleClassItems"
                  :itemText="'code_text'"
                  :itemValue="'code_value'"
                >
                </ryou-select>
              </v-col>
              <v-col cols="5" class="parkingAddBtn">
                <ryou-blue-btn
                  :label="'新規追加'"
                  :handlerClick="handleParkingAdd"
                >
                </ryou-blue-btn>
              </v-col>
            </v-row>
          </ryou-table>
        </v-form>
      </v-card>
      <ParkingInsertDialog ref="modalForm" @ok="modalFormOk" :url="url">
      </ParkingInsertDialog>
    </v-container>
  </v-form>
</template>
<script>
import RyouTable from "@/components/table/RyouTable.vue";
import RyouSelect from "@/components/formInput/RyouSelect.vue";
import RyouBlueBtn from "@/components/formInput/RyouBlueBtn.vue";
import ParkingInsertDialog from "./modules/ParkingInsertDialog.vue";
import { RyouTableMixins } from "@/mixins/RyouTableMixins";
export default {
  name: "DormitoryParkingList",
  mixins: [RyouTableMixins],
  components: {
    RyouSelect,
    RyouBlueBtn,
    ParkingInsertDialog,
    RyouTable,
  },
  data() {
    return {
      tableForm: true,
      rowKey: "rowIndex",
      businessKeys: ["build_group_id", "vehicle_class", "vehicle_id","user_id"],
      objectGroupItems: [],
      vehicleClassItems: [],
      selectGroup: "",
      selectVehicleClass: "",
      height: 640,
      headers: [
        {
          text: "",
          value: "build_group_id",
          class: "blue lighten-2 little",
          align: "right",
          width: "0.01%",
          type: "hidden",
          sortable: false,
          groupable: false,
          filter: this.groupFilter,
        },
        {
          text: "物件グループ名",
          align: "start",
          value: "build_group_name",
          width: "12%",
          sortable: true,
          groupable: false,
        },
        {
          text: "氏名",
          value: "user_name",
          width: "7%",
          sortable: true,
          groupable: false,
        },
        {
          text: "部屋番号",
          value: "room_id",
          width: "8%",
          sortable: true,
          groupable: false,
        },
        {
          text: "車両区分",
          value: "vehicle_class_name",
          width: "9%",
          sortable: true,
          groupable: false,
        },
        {
          text: "駐車番号",
          value: "vehicle_id",
          width: "9%",
          sortable: true,
          groupable: false,
        },
        {
          text: "車両名",
          value: "vehicle_name",
          width: "16%",
          sortable: true,
          groupable: false,
        },
        {
          text: "ナンバープレート",
          value: "number_plate",
          width: "13%",
          sortable: true,
          groupable: false,
        },
        {
          text: "利用開始日",
          value: "start_date",
          width: "9%",
          sortable: true,
          groupable: false,
        },
        {
          text: "利用終了日",
          value: "end_date",
          width: "9%",
          sortable: true,
          groupable: false,
        },
        {
          text: "操作",
          value: "actions",
          align: "center",
          class: "blue lighten-2 title",
          width: "6%",
          sortable: false,
          groupable: false,
        },
        {
          text: "",
          value: "vehicle_class",
          width: "0.01%",
          type: "hidden",
          sortable: false,
          groupable: false,
          filter: this.vehicleClassFilter,
        },
      ],
      url: {
        list:
          "/dormitoryParking/dormitoryParkingListGet" +
          "/" +
          this.$store.getters.getUserId +
          "/" +
          this.$store.getters.getUserClass,
        delete: "/dormitoryParking/dormitoryparkingDelete",
        update: "/dormitoryParking/dormitoryparkingUpdate",
        add: "/dormitoryParking/dormitoryparkingInsert",
      },
    };
  },
  created() {
    this.buildGroupList();
    this.vehicleClassNameList();
  },
  methods: {
    buildGroupList() {
      //物件グループ名
      let params = {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
      };
      this.getRequest(
        "/dormitoryParking/buildGroupGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          this.objectGroupItems = data.result;
          this.objectGroupItems.push("");
        }
      });
      setTimeout(() => {}, 100);
    },
    vehicleClassNameList() {
      //車両区分名
      let params = {
        userId: this.$store.getters.getUserId,
      };
      this.getRequest(
        "/dormitoryParking/vehicleClassNameGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          this.vehicleClassItems = data.result;
          this.vehicleClassItems.push("");
        }
      });
      setTimeout(() => {}, 100);
    },
    handleParkingAdd() {
      this.$refs.modalForm.add();
    },
    groupFilter(value) {
      if (!this.selectGroup) {
        return true;
      }
      return value.toLowerCase().includes(this.selectGroup.toLowerCase());
    },
    vehicleClassFilter(value) {
      if (!this.selectVehicleClass) {
        return true;
      }
      return value
        .toLowerCase()
        .includes(this.selectVehicleClass.toLowerCase());
    },
  },
};
</script>
<style scoped>
.parkingSelect {
  padding: 20px;
}

.parkingSelectBox {
  padding-top: 20px;
  text-align: right;
}

.parkingAddBtn {
  padding-top: 23px;
  padding-right: 0px;
  text-align: right;
}
</style>